<i18n lang="yaml">
ja:
  logout: ログアウト
en:
  logout: Logout
</i18n>

<template>
  <header class="ho-admin-header">
    <div class="title">
      <slot name="title">
        <span class="title-text">Admin</span>
      </slot>
    </div>
    <div class="right">
      <slot name="user" />
      <slot name="logout" />
    </div>
  </header>
</template>

<script lang="ts">
export default defineComponent({
  name: 'HoAdminHeader',
})
</script>

<script setup lang="ts">
//
</script>

<style lang="scss" scoped>
@use '#base/app/assets/styles/variables' as v;

.ho-admin-header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  height: v.$admin-header-height;
  padding: 0 20px;
  border-bottom: 1px solid v.$admin-border-color;

  background-color: v.$white;
  box-shadow: 0 1px 4px rgb(0 0 0 / 6%);

  > .title > .title-text {
    font-size: 16px;
    font-weight: 700;
    color: v.$admin-text-primary;
  }

  > .right {
    display: flex;
    gap: 12px;
    align-items: center;
  }
}
</style>
